import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import DashboardGridBox from '../DashboardGridBox.jsx';
import { toCommaNumber } from '../../../utils/format';

class AvgNetPayout extends DashboardGridBox {
    static propTypes = {
        selections: ImmutablePropTypes.list,
        status: PropTypes.string,

        getAvgNetPayouts: PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.title = 'Average net payout (selections in multiples)';

        this.columns = [
            {
                name: 'name',
                label: 'Selection',
                width: 6
            },
            {
                name: 'stake',
                label: 'Stakes',
                width: 2,
                class: 'widget-table__column-right'
            },
            {
                name: 'payout',
                label: 'Payout',
                width: 2,
                class: 'widget-table__column-right'
            },
            {
                name: 'anp',
                label: 'ANP',
                width: 2,
                class: 'widget-table__column-right'
            }
        ];

        this.buildData(this.props);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if ( this.props.selections !== props.selections ) {
            this.buildData(props);
        }

        // Start again the updates
        // when the customer is close/minimizez
        if ( props.stopTick !== this.props.stopTick ) {
            this.startTickUpdate(props);
        }
    }

    componentDidMount() {
        this.startTickUpdate(this.props);
    }

    startTickUpdate(props) {
        clearInterval(this.refresh);

        if ( props.stopTick ) {
            return;
        }

        props.getAvgNetPayouts();

        this.refresh = setInterval(() => {
            if (status === 'FINISHED') {
                props.getAvgNetPayouts();
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.refresh);
    }

    onClickRedirect(data, route, event) {
        event.preventDefault();

        let { eventId, marketId } = data;

        let path = '';
        let params = {
            market: parseInt(marketId, 10)
        };

        if ( route === 'liabilities') {
            path = '/trading?tab=liabilities&liabilities=multiple&liabilities';
            params = {
                ...params,
                event: parseInt(eventId, 10)
            };
        } else if ( route === 'market' ) {
            path = `/trading?*events=${eventId}&*events`;
            params = {
                ...params,
                tab: 'markets',
                filter: 'open'
            };
        }


        window.open(path + '.parameters=' + JSON.stringify(params));
    }

    buildData(props) {
        let { selections } = props;

        this.data = selections.reduce( (out, selection) => {
            let price = selection.getIn([ 'selection', 'price' ]);
            let priceLabel = price ? ` (${price.get('priceNum')}/${price.get('priceDen')})` : '';

            return out.concat([
                {
                    key: selection.getIn([ 'selection', 'id' ]) + selection.getIn([ 'market', 'id' ]),
                    eventId: parseInt(selection.getIn([ 'event', 'id' ]), 10),
                    marketId: parseInt(selection.getIn([ 'market', 'id' ]), 10),

                    payout: selection.get('payout') / 100,
                    netPayout: selection.get('netPayout') / 100,
                    stakes: selection.get('stakes') / 100,
                    name: selection.getIn([ 'selection', 'name' ]) + `${priceLabel}`,
                    event: selection.getIn([ 'event', 'name' ]) + ' - ' + selection.getIn([ 'market', 'name' ])
                }
            ]);
        }, []).sort( (prev, next) => prev.netPayout - next.netPayout );
    }

    renderTable() {
        const netPayoutHeader = (
            <div className="widget-table__header" key="avg-net-payout-header">
                <div className="row">
                    {
                        this.columns.map(col => {
                            return <div className={`col-${col.width} ${col.class}`} key={col.name}>{ col.label }</div>;
                        })
                    }
                </div>
            </div>
        );

        const netPayoutRows = this.data.map(item => {
            return (
                <div className={`widget-table__row`} key={ item.key }>
                    <div className="row">
                        <div className="col-6">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'market')}>
                                <strong>{ item.name }</strong>
                            </a>
                        </div>

                        <div className="col-2 widget-table__column-right">
                            { toCommaNumber(item.stakes) }
                        </div>

                        <div className="col-2 widget-table__column-right">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'liabilities')}>
                                { toCommaNumber(parseInt(item.payout, 10)) }
                            </a>
                        </div>

                        <div className="col-2 widget-table__column-right">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'liabilities')}>
                                { toCommaNumber(parseInt(item.netPayout, 10)) }
                            </a>
                        </div>

                        <div className="col-12 widget-table__text-small">
                            { item.event }
                        </div>
                    </div>
                </div>
            );
        });

        return [ netPayoutHeader, ...netPayoutRows ];
    }

    renderElement() {
        const { status } = this.props;
        const count = this.data.length;

        let spinner = null;
        if ( status === 'IN_PROGRESS' && count === 0 ) {
            spinner = <div className="spinner spinner--inline"> </div>;
        }

        const message = status === 'FINISHED' && count === 0 ? (
            <div className="widget-table__not-found">
                No net payouts
            </div>
        ) : null;

        return (
            <div className="avg-net-payout widget-table">
                { message }
                { spinner }
                { count ? this.renderTable() : null }
            </div>
        );
    }
}

AvgNetPayout.WIDTH = 4;
AvgNetPayout.HEIGHT = 8;
AvgNetPayout.X = 4;
AvgNetPayout.Y = 4;

export default AvgNetPayout;
